import CenteredContent from '@picsart/rc/old/CenteredContent';

import classNames from 'classnames';
import { Fragment } from 'react';

import useStyles from './styles';
import { ImageAndBulletListDataType } from './types';

type ImageAndBulletListSkeletonProps = {
  imageToRight: boolean;
  data: ImageAndBulletListDataType[];
};

function ImageAndBulletListSkeleton({ imageToRight, data }: ImageAndBulletListSkeletonProps) {
  const styles = useStyles({ imageToRight });

  const rootClassname = classNames(styles.root);
  return (
    <>
      <CenteredContent>
        <div className={rootClassname} data-testid="imageAndBulletListSkeleton">
          <div className={classNames(styles.content)}>
            <div className={styles.imageContainer}>
              <div className={styles.image}>
                <i className="skeleton" />
              </div>
            </div>
            <div className={styles.linesContainer}>
              <i className={classNames(styles.heading, 'skeleton')} />
              {data.map(({ title }) => (
                <Fragment key={title}>
                  <i className={classNames(styles.title, 'skeleton')} />
                  <i className={classNames(styles.subtitle, 'skeleton')} />
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </CenteredContent>
    </>
  );
}

export default ImageAndBulletListSkeleton;
